import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const DAY_VIDEO_REPORT_ID = `day${VIDEO_CAMPAIGN_SUFFIX}`;
